"use client";

import styled from "styled-components";

export const ScoreStar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Inter Regular";
  font-size: 15px;
  color: var(--textLight);
  gap: 3px;
  wdith: 100%;

  svg {
    width: 15px;
    height: 15px;
    stroke: var(--infoSystem);
    fill: var(--infoSystem);
    margin-top: -2px;
  }
`;
